import { AllSelection } from '@tiptap/pm/state';
import { isDefined } from 'ts-is-present';

import { INDENT_TYPE } from './../ricos-content';
import type { EditorPlugin, EditorProps } from './../ricos-types';
import { ToolbarType } from './../ricos-types';
import { isTextSelection } from './../editor-common';

import { pluginBlockquote } from './blockquote/blockquote';
import { pluginBold } from './bold/bold';
import { pluginBreakout } from './breakout/breakout';
import { pluginBulletedList } from './bulleted-list/bulleted-list';
import { pluginDraggable } from './draggable/draggable';
import { pluginFontSize } from './font-size/font-size';
import { pluginHardBreak } from './hard-break/hard-break';
import { pluginItalic } from './italic/italic';
import { pluginCell } from './layout/plugin-cell';
import { pluginLayout } from './layout/plugin-layout';
import { pluginListItem } from './list-item/list-item';
import { pluginNotOvertypable } from './not-overwritable/not-overtypable';
import { pluginOrderedList } from './ordered-list/ordered-list';
import { pluginParagraph } from './paragraph/paragraph';
import { pluginQuickActions } from './quick-actions/editor';
import { pluginResizable } from './resizable/resizable';
import { pluginSelection } from './selection/selection';
import { pluginSpotlight } from './spotlight/spotlight';
import { pluginTab } from './tab/tab';
import { pluginTextAlignment } from './text-align/text-align';
import { pluginTitle } from './title/title';
import type { EditorPluginOptions } from './types';
import { pluginUnderline } from './underline/underline';
import { pluginUndoRedo } from './undo-redo/undo-redo';
import { unsupportedPlugin } from './unsupported/unsupported';

export type {} from './blockquote/extension';
export type {} from './bold/extension';
export type {} from './breakout/extension';
export type {} from './bulleted-list/extension';
export type {} from './draggable/extension';
export type {} from './font-size/extension';
export type {} from './hard-break/extension';
export type {} from './italic/extension';
export type {} from './list-item/extension';
export type {} from './ordered-list/extension';
export type {} from './paragraph/extension';
export type {} from './resizable/extension';
export type {} from './selection/extension';
export type {} from './tab/extension';
export type {} from './text-align/extension';
export type {} from './title/extension';
export type {} from './underline/extension';
export type {} from './undo-redo/history';

export const commonPlugins = (editorProps: EditorProps, pluginOptions: EditorPluginOptions[]) => {
  const layoutConfig = pluginOptions.find(({ type }) => type === 'LAYOUT');
  return [
    pluginBlockquote,
    pluginBold,
    pluginBulletedList,
    pluginFontSize,
    pluginItalic,
    pluginListItem,
    pluginOrderedList,
    pluginParagraph,
    pluginTextAlignment,
    pluginUnderline,
    pluginResizable,
    pluginDraggable,
    pluginUndoRedo,
    pluginTitle,
    pluginHardBreak,
    pluginBreakout,
    pluginTab,
    pluginSelection,
    pluginNotOvertypable,
    unsupportedPlugin,
    pluginLayout(layoutConfig),
    pluginCell(layoutConfig),
    pluginQuickActions({
      ...editorProps?.toolbarSettings
        ?.getToolbarSettings?.({})
        ?.find(({ name }) => name === ToolbarType.QUICK_ACTIONS),
    }),
    pluginSpotlight,
  ].filter(isDefined) as EditorPlugin<Record<string, any>>[];
};

export const commonPluginConfig = {
  [INDENT_TYPE]: { isTextSelection, AllSelection },
};
